import React from 'react';
import styled from 'styled-components';

import { SubtitlePrimary } from '../Base';

const StyledRibbon = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
  height: 32px;
  margin-left: ${p => p.theme.spacing(2)};
  padding: 0 ${p => p.theme.spacing(2)};
  color: ${p => p.theme.colours.white};
  background: no-repeat right,
    linear-gradient(
      to right,
      ${p => p.theme.colours.bright_blue},
      ${p => p.theme.colours.vivid_cyan}
    );
  z-index: 0;

  &:before {
    content: '';
    position: absolute;
    left: -16px;
    top: 0;
    height: 0;
    width: 0;
    border: none;
    border-top: 16px solid transparent;
    border-bottom: 16px solid transparent;
    border-right: 16px solid ${p => p.theme.colours.bright_blue};
  }
`;

const StyledSubtitlePrimary = styled(SubtitlePrimary)`
  margin-top: 3px;
`;

const PromoRibbon = props => {
  const { children } = props;

  return (
    <StyledRibbon>
      <StyledSubtitlePrimary>{children}</StyledSubtitlePrimary>
    </StyledRibbon>
  );
};

export default PromoRibbon;
